import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EconomicTestService } from 'src/app/services/economic-test.service';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { IPFolder, IPUser } from 'src/app/classes/enum/interfaces/economic-test.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { Router } from '@angular/router';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { DarkModeService } from 'src/app/services/dark-mode.service';


@Component({
  selector: 'app-economic-test',
  templateUrl: './economic-test.component.html',
  styleUrls: ['./economic-test.component.scss']
})
export class EconomicTestComponent implements OnInit {

  href='http://localhost:4200/'
  searchForm: FormGroup;
  filteredUsers: IPUser[];
  users: IPUser[];
  public userFilterCtrl: FormControl = new FormControl('');

  folders: IPFolder[];
  filteredSubFolders: IPFolder[];
  public subFolderFilterCtrl: FormControl = new FormControl('');

  private _onDestroy = new Subject<void>();

  fileFormats = [
    { value: 'Word', selected: false },
    { value: 'Excel', selected: false },
    { value: 'PowerPoint', selected: false },
    { value: 'Text', selected: false },
    { value: 'PDF', selected: false }
  ];

  isUserDropdownOpen = false;
  isFolderDropdownOpen = false;
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = [
    'Document name',
    'Document format',
    'Document creator',
    'Creation date',
    'Modification date',
    'Document location',
    'Page'
  ];
  tableData 
  errorMessage = 'We had a problem. Please try again in a few minutes'
  errorTokenMessage = 'Your token has expired please go back to launchpad'
  dataMeessage = ''

  constructor(
    private fb: FormBuilder, 
    private economicTestService: EconomicTestService, 
    private router: Router, 
    private authorizationService: AuthorizationService,
    private darkModeService: DarkModeService,
    
  ) { }
  @ViewChild('userSelect') userSelect: MatSelect;
  @ViewChild('folderSelect') folderSelect: MatSelect;

  ngAfterViewInit() {
     // userSelect
  this.handleSelect(this.userSelect);
  
  // folderSelect
  this.handleSelect(this.folderSelect);

  }

  private handleSelect(select: MatSelect) {
    if (select) {
      select.openedChange.subscribe(opened => {
        if (opened) {
            const formField = select._elementRef.nativeElement.closest('.mat-form-field');
            
            if (formField) {
              const formFieldRect = formField.getBoundingClientRect();
              
              const overlayPane = document.querySelector('.cdk-overlay-pane') as HTMLElement;
              
              if (overlayPane) {
                // overlayPane.style.width = `${formFieldRect.width}px`;
                // overlayPane.style.left = `${formFieldRect.left}px`;
                overlayPane.style.top = `${formFieldRect.bottom}px`;
                
                const panel = document.querySelector('.mat-select-panel') as HTMLElement;
                if (panel) {
                  // panel.style.width = '50%';
                  // panel.style.minWidth = '50%';
                  // panel.style.maxWidth = '50%';
                }
              }
            }
        }
      });
    }
  }

  ngOnInit() {
    this.getAllIpUser()
    this.getAllIpSubFolder()
    this.searchForm = this.fb.group({
      freeSearch: [''],
      selectedUsers: [[]],
      selectedSubFolders: [[]],
      fromDate: [''],
      toDate: [''],
      sortByLastModified: [false]
    });

    this.userFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterUsers();
      });

    this.subFolderFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterSubFolders();
    });
  }


  get freeSearchControl(): FormControl {
    return this.searchForm.get('freeSearch') as FormControl;
  }

  get selectedUsersControl(): FormControl {
    return this.searchForm.get('selectedUsers') as FormControl;
  }

  get selectedSubFolderControl(): FormControl {
    return this.searchForm.get('selectedSubFolders') as FormControl;
  }

   async getAllIpUser(){
    await this.economicTestService.getAllIp('economic-tests/ip-user').subscribe(
      (response) => {
        // console.log("response getAllIpUser", response)
        this.users = response
        this.filteredUsers = response
      },
      (error) => {
        // Handle error
        console.error('Error:', error);
      }
    );
  }

  async getAllIpSubFolder(){
    await this.economicTestService.getAllIp('economic-tests/ip-sub-folders').subscribe(
      (response) => {
        // console.log("response getAllIpSubFolder", response)
        this.folders = response
        this.filteredSubFolders = response
      },
      (error) => {
        // Handle error
        console.error('Error:', error);
      }
    );
  }
  
  filterUsers() {
    const search = this.userFilterCtrl.value?.toLowerCase() || '';
    this.filteredUsers = this.users.filter(user =>
      user.user_name.toLowerCase().includes(search)
    );
  }

  filterSubFolders() {
    const search = this.subFolderFilterCtrl.value?.toLowerCase() || '';
    this.filteredSubFolders = this.folders.filter(folder =>
      folder.name.toLowerCase().includes(search)
    );
  }

  toggleFileFormat(format) {
    format.selected = !format.selected;
  }


  getUsersLabel(): string {
    const selected = this.searchForm.get('selectedUsers')?.value;
    if (selected.length === 0) {
      return 'Select User';
    } else if (selected.length === 1) {
      return selected[0].name;
    } else {
      return `${selected.length} User Selected`;
    }
  }

  getFoldersLabel(): string {
    const selected = this.searchForm.get('selectedSubFolders')?.value;
    if (selected.length === 0) {
      return 'Select Sub Folder';
    } else if (selected.length === 1) {
      return selected[0].name;
    } else {
      return ` ${selected.length} Sub folder Selected`;
    }
  }

  async onSearch() {
    this.dataMeessage = ''
    console.log('Form submitted', this.searchForm.value);
    const formatSelectedValues = this.fileFormats
    .filter(format => format.selected)
    .map(format => format.value);
    const params = {
      keywords: this.searchForm.get('freeSearch')?.value,
      start_date: this.searchForm.get('fromDate')?.value,
      end_date: this.searchForm.get('toDate')?.value,
      format_q: formatSelectedValues,
      creator: this.searchForm.get('selectedUsers')?.value,
      subfolders: this.searchForm.get('selectedSubFolders')?.value,
      sort_field: this.searchForm.get('sortByLastModified')?.value == true ? 'modification_date': 'None',
      sort_order : 'desc'
      // keywords: this.searchForm.get('freeSearch')?.value,
      // start_date: this.searchForm.get('fromDate')?.value,
      // end_date: this.searchForm.get('toDate')?.value,
      // format_q: '',
      // creator: '',
      // subfolders: this.searchForm.get('selectedSubFolders')?.value,
      // modification_date: this.searchForm.get('sortByLastModified')?.value == true ? 'modification_date': 'None',
      // sort_order : 'desc'
    }

    if(
      params.keywords == '' && 
      params.start_date == '' && 
      params.end_date == ''  &&
      !params.format_q?.length && 
      !params.creator?.length && 
      !params.subfolders?.length 
    ){
      this.setError('At least one filter option must be selected.')
      return;
    }

    await this.economicTestService.getTableData('economic-tests', params).subscribe(
      (response) => {
        if (response.status == 403) {
          if (this.authorizationService.isLoggedInNewClientId() == true)
            this.setError(this.errorMessage)
          else
            this.setError(this.errorTokenMessage)
        }
        if(response.status == 'failed'){
          this.setError(this.errorMessage)
        } else if(response.data){
          if(response.data.length == 0){
            this.dataMeessage = 'No data matches the search.'
          }
          this.tableData = response.data;
          const processedData = this.tableData.map(doc => ({
            ...doc,
            Page: doc?.Page.join(', ')
          }));
      
          this.dataSource = new MatTableDataSource(processedData);
          this.dataSource.paginator = this.paginator;
        }
        
      },
      (error) => {
        // Handle error
        console.error('Error:', error);
      }
    );
  }

  copyToClipboard(value: string): void {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => {
      console.log('Copied to clipboard:', value);
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }

  clearForm() {
    this.searchForm.reset({
      freeSearch: '',
      selectedUsers: [],
      selectedFolders: [],
      fromDate: '',
      toDate: '',
      sortByLastModified: false
    });
    
    this.fileFormats.forEach(format => format.selected = false);
    this.dataSource.data = [];
    this.dataMeessage = ''
  }

  // Close dropdowns when clicking outside
  onClickOutside(dropdown: string) {
    if (dropdown === 'user') {
      this.isUserDropdownOpen = false;
    } else if (dropdown === 'folder') {
      this.isFolderDropdownOpen = false;
    }
  }

  get isDarkMode() {
    return this.darkModeService.isDarkMode && this.router.url != '/';
  }


  goBack() {
    this.router.navigateByUrl('postauth');
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  setError(errorMessage){
     Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: errorMessage,
    });
  }
}

